import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {BIRTH_CONTROL_TELECONSULTATION_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire4Screen';
import Questionnaire4bScreen from '~/pages/homes/birth-control-teleconsultation/Questionnaire4bScreen';
import Questionnaire6Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire9Screen';
import Questionnaire10Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire10Screen';
import Questionnaire11Screen from '~/pages/homes/birth-control-teleconsultation/Questionnaire11Screen';
import {trackPageViewGA} from '~/services/google-analytics';

const BirthControlTeleconsultation = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);

  const questionnaires = medicalQuestionnaire?.questionnaires;

  if (!questionnaires?.length) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.START:
        trackPageViewGA('/bc-tel/start', 'MDQ-BC Tel - Start');
        return <Questionnaire1Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.PROFILE:
        trackPageViewGA('/bc-tel/profile', 'MDQ-BC Tel - Profile');
        return <Questionnaire2Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.INVALID:
        trackPageViewGA('/bc-tel/invalid', 'MDQ-BC Tel - Invalid');
        return <Questionnaire3Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.BRAND_USED:
        trackPageViewGA('/bc-tel/brand-used', 'MDQ-BC Tel - Brand Used');
        return <Questionnaire4Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.LAST_BC_PURCHASE:
        trackPageViewGA('/bc-tel/last-bc-purchase', 'MDQ-BC Tel - Last BC Purchase');
        return <Questionnaire4bScreen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.MEDICAL_HISTORY:
        trackPageViewGA('/bc-tel/medical-history', 'MDQ-BC Tel - Medical History');
        return <Questionnaire6Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH:
        trackPageViewGA(
          '/bc-tel/had-blood-pressure-measured-last-6-month',
          'MDQ-BC Tel - Had Blood Pressure Measured Last 6 Month',
        );
        return <Questionnaire7Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.DO_SMOKE:
        trackPageViewGA('/bc-tel/do-smoke', 'MDQ-BC Tel - Do Smoke');
        return <Questionnaire8Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.HAS_SMOKED:
        trackPageViewGA('/bc-tel/has-smoked', 'MDQ-BC Tel - Has Smoked');
        return <Questionnaire9Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.MEDICATION_BEING_TREATED:
        trackPageViewGA('/bc-tel/medication-being-treated', 'MDQ-BC Tel - Medication Being Treated');
        return <Questionnaire10Screen />;
      case BIRTH_CONTROL_TELECONSULTATION_KEYS.OTHER_MEDICAL_HISTORY:
        trackPageViewGA('/bc-tel/other-medical-history', 'MDQ-BC Tel - Other Medical History');
        return <Questionnaire11Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return renderQuestion();
};

export default BirthControlTeleconsultation;
